
define('ldsh!modules/start/products/base/logobutton/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-4 col-sm-2 col-md-2 col-lg-2 first-column text-center">\n    <img src="/app/img/' +
__e(logoName) +
'.png" class="img-responsive img-products center-block">\n    ';
 if (active) { ;
__p += '\n        <a id="' +
__e(logoName) +
'" class="btn boton-entrar redirect-btn i18n" data-i18n="PUBLIC.PRODUCTS.BTN_ENTER"></a>\n    ';
 } else { ;
__p += '\n        <a class="btn boton-entrar activate-btn i18n" data-i18n="PUBLIC.PRODUCTS.BTN_ACTIVATE"></a>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

